import { Theme } from '@material-ui/core/styles';
import { SvgIconClassKey } from '@material-ui/core/SvgIcon';

const MuiSvgIcon = (theme: Theme): Partial<Record<SvgIconClassKey, unknown>> => ({
    root: {
        display: 'flex',
    },
    colorAction: {
        color: theme.palette.grey[500],
    },
});

export default MuiSvgIcon;
